export default {
    brand: 'motortech',
    logo: '/motortech/logo_white_motortech.svg',
    logoHeight: '42',
    logoSmall: '/motortech/logo_white_small_motortech.svg',
    logoSmallHeight: '30',
    logoBlack: '/motortech/logo_couleur.svg',
    logoBlackSmall: '/motortech/logo_black_small_motortech.svg',
    companyName: 'Motortech'
};
